<template>
  <div>
    <Collapse accordion>
      <Panel :name="item.ClassificationID" v-for="item of lists" :key="item.ClassificationID">
        <Avatar :src="item.IconUrl" />
        {{ item.Classification }}
        <div slot="content">
          单位: （{{ item.unit }}）
          <Button
            type="info"
            icon="ios-add"
            @click="NewBuildMainHandleClick(item.ClassificationID)"
          >新增</Button>
          <Collapse accordion>
            <Panel
              :name="item1.SingleWeight_ID"
              v-for="item1 of item.SingleWeightModel"
              :key="item1.SingleWeight_ID"
            >
              {{ item1.SingleWeight_Value }}
              <List slot="content">
                <ListItem>
                  <li>
                    <Button
                      type="primary"
                      shape="circle"
                      icon="ios-create-outline"
                      @click="EditSingleWeightHandleClick(item1, item.ClassificationID)"
                    >编辑</Button>
                  </li>
                  <li style="margin-left:2rem">
                    <Button
                      type="error"
                      shape="circle"
                      icon="ios-close"
                      @click="DeleteSingleWeightHandleClick(item1)"
                    >删除</Button>
                  </li>
                </ListItem>
                <ListItem>
                  <Button
                    type="dashed"
                    icon="ios-add"
                    long
                    @click="NewBuildAuxiliaryQuantityHandleClick(item1.SingleWeight_ID)"
                  >新增</Button>
                </ListItem>
                <ListItem v-for="item2 of item1.AuxiliaryQuantity" :key="item2.AuxiliaryQuantity_ID">
                  <ListItemMeta :description="item2.AuxiliaryQuantityt_Value" />
                  <template slot="action">
                    <li>
                      <Button
                        type="primary"
                        shape="circle"
                        icon="ios-create-outline"
                        @click="EditAuxiliaryQuantityHandleClick(item2,item1.SingleWeight_ID)"
                      >编辑</Button>
                    </li>
                    <li>
                      <Button
                        type="error"
                        shape="circle"
                        icon="ios-close"
                        @click="DeleteAuxiliaryQuantityHandleClick(item2)"
                      >删除</Button>
                    </li>
                  </template>
                </ListItem>
              </List>
            </Panel>
          </Collapse>
        </div>
      </Panel>
    </Collapse>
    <span></span>
    <Drawer title="物料单重维护" v-model="isDrawer" width="80" :mask-closable="false" >
        <Form  :model="FormData" ref="formCustom" :rules="ruleCustom" label-position="left">
           <FormItem label="单重" prop="SingleWeight_Value">
             <Input type="number" v-model="FormData.SingleWeight_Value" value="FormData.SingleWeight_Value" />
           </FormItem>
        </Form>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px" @click="CancelHandleClick">取消</Button>
          <Button type="primary" @click="SubmitHandleClick('formCustom')">提交</Button>
        </div>
    </Drawer>
    <span></span>
    <Drawer title="物料辅助数量维护" v-model="isDrawer2" width="80" :mask-closable="false" >
        <Form  :model="FormData2" ref="formCustom2" :rules="ruleCustom2" label-position="left">
           <FormItem label="辅助数量" prop="AuxiliaryQuantityt_Value">
             <Input type="number" v-model="FormData2.AuxiliaryQuantityt_Value" value="FormData.SingleWeight_Value" />
           </FormItem>
        </Form>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px" @click="CancelHandleClick2">取消</Button>
          <Button type="primary" @click="SubmitHandleClick2('formCustom2')">提交</Button>
        </div>
    </Drawer>
  </div>
</template>

<script>
import { QuantitativeRulesListApi, ChangeSingleWeightData, ChangeAuxiliaryQuantityData } from '../../../api/Materiel'
export default {
  name: 'QuantitativeRules',
  data () {
    const validateSingleWeightValue = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('请输入单重'))
      } else {
        callback()
      }
    }
    const validateAuxiliaryQuantitytValue = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('请输入辅助数量'))
      } else {
        callback()
      }
    }
    return {
      lists: [],
      isDrawer: false,
      isDrawer2: false,
      FormData: {
        SingleWeight_ID: '',
        SingleWeight_Value: 0,
        ClassificationID: ''
      },
      FormData2: {
        AuxiliaryQuantity_ID: '',
        AuxiliaryQuantityt_Value: 0,
        SingleWeight_ID: ''
      },
      FormState: 0,
      FormState2: 0,
      ruleCustom: {
        SingleWeight_Value: [{ validator: validateSingleWeightValue, trigger: 'blur' }]
      },
      ruleCustom2: {
        AuxiliaryQuantityt_Value: [{ validator: validateAuxiliaryQuantitytValue, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetQuantitativeRulesList()
  },
  methods: {
    // 获取数量规则数据
    GetQuantitativeRulesList () {
      QuantitativeRulesListApi().then((res) => {
        if (res.IsSuccess) {
          this.lists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击单重新建按钮事件
    NewBuildMainHandleClick (ClassificationID) {
      this.FormState = 0
      this.FormData = {
        SingleWeight_ID: '',
        SingleWeight_Value: 0,
        ClassificationID: ClassificationID
      }
      this.isDrawer = true
    },
    // 单重弹窗点击取消按钮回调
    CancelHandleClick () {
      this.isDrawer = false
    },
    // 单重弹窗点击提交回调事件
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.SingleWeightSubmitHandleClick()
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    // 点击单重编辑按钮回调
    EditSingleWeightHandleClick (item, ClassificationID) {
      this.FormState = 1
      this.FormData = {
        SingleWeight_ID: item.SingleWeight_ID,
        SingleWeight_Value: item.SingleWeight_Value,
        ClassificationID: ClassificationID
      }
      this.isDrawer = true
    },
    // 点击单重删除按钮回调
    DeleteSingleWeightHandleClick (item) {
      this.FormState = 2
      this.FormData.SingleWeight_ID = item.SingleWeight_ID
      this.SingleWeightSubmitHandleClick()
    },
    // 提交单重弹窗数据到后台
    SingleWeightSubmitHandleClick () {
      ChangeSingleWeightData({
        SingleWeight_ID: this.FormData.SingleWeight_ID,
        SingleWeight_Value: this.FormData.SingleWeight_Value,
        ClassificationID: this.FormData.ClassificationID,
        operation: this.FormState
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetQuantitativeRulesList()
          this.isDrawer = false
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击辅助数量新增回调
    NewBuildAuxiliaryQuantityHandleClick (SingleWeightID) {
      this.FormState2 = 0
      this.FormData2 = {
        AuxiliaryQuantity_ID: '',
        AuxiliaryQuantityt_Value: 0,
        SingleWeight_ID: SingleWeightID
      }
      this.isDrawer2 = true
    },
    // 点击辅助数量取消按钮回调
    CancelHandleClick2 () {
      this.isDrawer2 = false
    },
    // 点击辅助数量弹窗提交回调事件
    SubmitHandleClick2 (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.AuxiliaryQuantitySubmitHandleClick()
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    // 点击辅助数量编辑按钮回调
    EditAuxiliaryQuantityHandleClick (item, SingleWeightID) {
      this.FormState2 = 1
      this.FormData2 = {
        AuxiliaryQuantity_ID: item.AuxiliaryQuantity_ID,
        AuxiliaryQuantityt_Value: item.AuxiliaryQuantityt_Value,
        SingleWeight_ID: SingleWeightID
      }
      this.isDrawer2 = true
    },
    // 点击辅助数量删除按钮回调
    DeleteAuxiliaryQuantityHandleClick (item) {
      this.FormState2 = 2
      this.FormData2.AuxiliaryQuantity_ID = item.AuxiliaryQuantity_ID
      this.AuxiliaryQuantitySubmitHandleClick()
    },
    // 提交辅助数量数据到后台
    AuxiliaryQuantitySubmitHandleClick () {
      const value = Number(this.FormData2.AuxiliaryQuantityt_Value)
      ChangeAuxiliaryQuantityData({
        AuxiliaryQuantity_ID: this.FormData2.AuxiliaryQuantity_ID,
        AuxiliaryQuantityt_Value: value,
        SingleWeight_ID: this.FormData2.SingleWeight_ID,
        operation: this.FormState2
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetQuantitativeRulesList()
          this.isDrawer2 = false
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
